import type { ClientResetPersonFeatureRequest } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useSharedFeatureEventsApi } from '@/features/api/hooks/shared-feature/useSharedFeatureEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useResetPersonFeature = () => {
  const queryClient = useQueryClient();
  const api = useSharedFeatureEventsApi();

  return useApiMutation({
    mutationFn: (
      clientResetPersonFeatureRequest: ClientResetPersonFeatureRequest
    ) => api.onResetPersonFeatureRequest({ clientResetPersonFeatureRequest }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [API_CACHE_KEYS.FEATURES] });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.POST_CREATION_OPTIONS]
      });
    }
  });
};
